import Map from "./map/map";
import Layout from "../common";

function index() {
  return (
    <Layout>
      <Map />
    </Layout>
  );
}

export default index;
